/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { User } from '@modules/cloud-api/v1/types'

import { isCurrentUser } from '@/reducers/currentUser'
import { updateUserRequest } from '@/reducers/asyncRequests/registry'

import { updateNativeUser } from '../../../../../../actions/localUsers'
import UserFlyout from '../UserFlyout'

import type { ReduxState, ThunkDispatch } from '@/types/redux'

const mapStateToProps = (state: ReduxState, { regionId }) => ({
  isCurrentUser: (username: string) => isCurrentUser(state, username),
  onSaveRequestState: updateUserRequest(state, regionId),
})

const mapDispatchToProps = (dispatch: ThunkDispatch) => ({
  onSave: (user: User) => dispatch(updateNativeUser(user)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UserFlyout)
